import { CaretDownOutlined, CaretRightOutlined } from "@ant-design/icons";
import { Col, Collapse, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import HighlightsList from "../highlightsList";
import ProductCertifications from "../productCertifications";
// import ProductRequired from "../productRequired";
import "./style.scss";

const ProductOverview = (props: any) => {
  const { product } = props;
  const { Panel } = Collapse;
  const { t } = useTranslation();

  return (
    <Row align="top" justify="center">
      <Col span={24} className="product-overview-container">
        {product.certifications && product.certifications.length ? (
          <>
            <Row className="product-overview-title product-overview-title__certification main-content">
              <li>{t("product_certifications")}</li>
            </Row>
            <ProductCertifications certifications={product.certifications} />
          </>
        ) : null}
        <Row className="product-overview-collapse-wrapper">
          <Collapse
            // accordion
            defaultActiveKey={["1", "2"]}
            bordered={false}
            ghost
            expandIconPosition="right"
            expandIcon={({ isActive }) =>
              isActive ? (
                <div className="product-overview-title main-content">
                  <CaretRightOutlined />
                  <CaretRightOutlined />
                </div>
              ) : (
                <CaretDownOutlined className="product-overview-title main-content" />
              )
            }>
            {product.long_description && (
              <Panel
                header={
                  <Row className="product-overview-title main-content">
                    <li>{t("product_overview")}</li>
                  </Row>
                }
                key="1">
                <div
                  dangerouslySetInnerHTML={{
                    __html: product.long_description.replaceAll(
                      "background-color: #ffffff;",
                      `background-color: transparent;`
                    ),
                  }}></div>
              </Panel>
            )}
            {product.highlights && product.highlights.length && (
              <Panel
                header={
                  <Row className="product-overview-title main-content">
                    <li>{`${t("features")}`}</li>
                  </Row>
                }
                key="2">
                <HighlightsList highlights={product.highlights} />
              </Panel>
            )}
            {product.user_manual && (
              <Panel
                header={
                  <Row className="product-overview-title main-content">
                    <li>{t("product_guide")}</li>
                  </Row>
                }
                key="3">
                <div
                  dangerouslySetInnerHTML={{
                    __html: product.user_manual.content.replaceAll(
                      "background-color: #ffffff;",
                      `background-color: transparent;`
                    ),
                  }}></div>
              </Panel>
            )}
          </Collapse>
        </Row>
      </Col>
    </Row>
  );
};

export default ProductOverview;
